export default "__VITE_ASSET__a4ffe877__"